import { BaseCard } from 'modules/design-system';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthBaseCardHeader } from '../../../components/AuthBaseCardHeader/AuthBaseCardHeader';
import { SendTokenForm } from '../../../components/SendTokenForm/SendTokenForm';
import { Message } from '../../index.css';

type SendTokenProps = {
  email?: string;
  locale?: string;
};

export const SendToken = ({ email = '', locale = 'fr' }: SendTokenProps) => {
  const [t] = useTranslation('user');
  const [resetTokenSent, setResetTokenSent] = useState(false);

  return (
    <BaseCard>
      <AuthBaseCardHeader
        title={
          resetTokenSent
            ? t('user.resetPassword.tokenConfirmation.header')
            : t('user.resetPassword.tokenForm.header')
        }
      />
      {resetTokenSent ? (
        <Message>{t('user.resetPassword.tokenConfirmation.message')}</Message>
      ) : (
        <SendTokenForm
          defaultEmail={email}
          locale={locale}
          onSuccess={() => setResetTokenSent(true)}
        />
      )}
    </BaseCard>
  );
};
